import { createSlice } from "@reduxjs/toolkit";
import { InitialQualityFormData } from "../../ConstantData/InitialData";

const qualitySlice = createSlice({
  name: "quality",
  initialState: {
    qualityList: [],
    dataEdit: [],
    isError: false,
    errorData: {},
    initialData: InitialQualityFormData,
  },
  reducers: {
    getAllQuality: (state, action) => {
      state.qualityList = action.payload;
    },
    getQuality: () => {},
    createQuality: (state, action) => {},
    getQualityDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state, action) => {
      state.initialData = { ...InitialQualityFormData };
    },
    updateQuality: (state, action) => {},
    deleteQuality: () => {},
  },
});

export const qualitySliceAction = qualitySlice.actions;
export default qualitySlice.reducer;
